var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("aside", { staticClass: "popup-external-link" }, [
    _vm.$root.states.popupExternalLinkHref
      ? _c("div", { staticClass: "popup-overlay" }, [
          _c("div", { staticClass: "popup" }, [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "popup-footer" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-pink-white-black-white",
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      return _vm.cancelPopup()
                    }
                  }
                },
                [_vm._v("\n                    Abbrechen\n                ")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-pink-white-black-white",
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      return _vm.confirmPopup()
                    }
                  }
                },
                [_vm._v("\n                    Weiter\n                ")]
              )
            ])
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "popup-body" }, [
      _c("h4", [_vm._v("\n                    Hinweis:\n                ")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n                    Sie haben einen Link ausgewählt, der Sie auf eine nicht von Gilead Sciences betriebene Website führt.\n                    Klicken Sie auf „Abbrechen“, um auf dieser Seite zu verbleiben, oder auf „Weiter“, um auf die neue Seite\n                    zu gelangen.\n                "
        )
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5a02ee74", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a02ee74","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./public/js/components/PopupExternalLink.vue
// module id = 552
// module chunks = 0